import { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import TopHeader from "../../components/layouts/TopHeader";
import { ApiConstants } from "../../constants/ApiConstants";
import authContext from "../../context/authContext";
import useMakeRequest from "../../utils/ApiHelper";
import { getFrequencyDates, isDateFinalized } from "../../utils/Helper";
import PaymentChart from "../payment/PaymentChart";
import dummyUser from "../../assets/images/menu/account.svg";
import { Tooltip as ReactTooltip } from "react-tooltip";
import chevRight from '../../assets/images/chev-right.svg'



function PaymentReport({ fromReport = false }: any) {

    const unAssignedExpenses = useMakeRequest();
    const hhMembers = useMakeRequest();
    const markAsPaid = useMakeRequest();
    const paymentSummary = useMakeRequest();
    let profile: any = useContext(authContext);
    profile = profile?.data;

    console.log("profile: ", profile)

    const [cumulativeBalance, setCumulativeBalance] = useState<string | null>("");
    const [jointTotal, setJointTotal] = useState<string | number>("0");
    const [members, setMembers] = useState<any>([]);
    const [payerOptions, setPayerOptions] = useState<any>([]);
    console.log("payerOptions", payerOptions)
    const [unAssignedData, setUnAssignedData] = useState([])
    const [finalizedMonth, setFinalizedMonth] = useState([])

    const [uiState, setUiState] = useState<any>([]);

    const [totalPaymentMade, setTotalPaymentMade] = useState<any>(0);
    const [totalPaymentReceived, setTotalPaymentReceived] = useState<any>(0);
    const [totalPaymentMadeBy, setTotalPaymentMadeBy] = useState<any>([]);
    const [totalPaymentReceivedBy, setTotalPaymentReceivedBy] = useState<any>([]);

    const [isFinalized, setIsFinalized] = useState(false);
    console.log("isFinalized: ", isFinalized)

    const [expandedSections, setExpandedSections] = useState<{ [key: string]: boolean }>({
        totalPaymentMade: false,
        totalPaymentReceived: false
    });

    const toggleSection = (section: string) => {
        setExpandedSections(prev => ({
            ...prev,
            [section]: !prev[section]
        }));
    }

    useEffect(() => {
        if (unAssignedData?.length > 0) {
            const ui = unAssignedData.flatMap((cat: any) =>
                cat.expenses.map((exp: any) => {
                    let selectedPayer = null;

                    // ⭐ If it is a joint account expense → auto-select Joint Account
                    if (exp.is_joint_account === 1) {
                        selectedPayer = payerOptions.find((p: any) => p.value === "01");
                    }
                    // Otherwise use payer from API
                    else if (exp.payer && exp.payer !== 0) {
                        selectedPayer = payerOptions.find((p: any) => p.value === exp.payer);
                    }

                    return {
                        category_id: cat.category_id,
                        expenseId: exp.id,
                        selectedPayer,
                        isPaid: exp.is_unpaid === 0,
                    };
                })
            );

            setUiState(ui);
        }
    }, [unAssignedData, payerOptions]);




    const STATIC_PAYER_OPTIONS = [
        { value: "01", label: "Joint Account" },
    ];

    console.log("members: ", members)

    useEffect(() => {
        if (profile?.hh_member?.household?.uuid) {
            hhMembers.makeRequest({
                url: ApiConstants?.GetHouseholdMembers,
                payload: { hh_id: profile?.hh_member?.household?.uuid },
            });
        }
    }, [profile?.hh_member]);

    useEffect(() => {
        if (hhMembers?.status) {
            console.log("hhMembers: ", hhMembers)
            const transformedData = hhMembers?.data?.data?.map((item: any) => ({
                value: item?.user?.id,
                label: profile?.id === item?.user?.id ? `Me` : item?.user?.name,
            }));

            // Merge with static options
            setPayerOptions([...transformedData, ...STATIC_PAYER_OPTIONS]);
        }
    }, [hhMembers?.status]);

    useEffect(() => {
        if (profile?.hh_member?.household?.id) {
            getPaymentSummary();
        }
    }, [profile?.hh_member?.household?.id])

    const getPaymentSummary = () => {
        paymentSummary.makeRequest({
            url: ApiConstants?.paymentSummary,
            payload: { hh_id: profile?.hh_member?.household?.id },
        });
    }


    useEffect(() => {
        if (paymentSummary?.status) {
            console.log("paymentSummary: ", paymentSummary?.data?.data)
            setTotalPaymentMade(paymentSummary?.data?.data?.total_payments_made)
            setTotalPaymentReceived(paymentSummary?.data?.data?.total_payments_received)
            setTotalPaymentMadeBy(paymentSummary?.data?.data?.payments_made_by)
            setTotalPaymentReceivedBy(paymentSummary?.data?.data?.payments_received_by)
        }
    }, [paymentSummary])


    useEffect(() => {
        APIcallUnassignedExpenceList();
    }, [])

    const APIcallUnassignedExpenceList = () => {
        unAssignedExpenses.makeRequest({ url: ApiConstants?.UnAssignedExpenses, type: 'POST' }).then((res) => {
            if (res.status) {
                setUnAssignedData(res?.data?.category_wise_data)
                let category_wise_data = res?.data?.category_wise_data
                if (category_wise_data?.length > 0) {
                    let finalized = false;

                    category_wise_data.forEach((cat: any) => {
                        cat.expenses.forEach((exp: any) => {
                            const freqDays = getFrequencyDates(
                                exp?.s_date,
                                exp?.e_date,
                                exp?.f_type,
                                exp?.f_value,
                                exp?.s_days_or_months
                            );
                            console.log("finalizedMonth: ", finalizedMonth)
                            freqDays.forEach((date: string) => {
                                if (
                                    isDateFinalized(date, res?.data?.finalized_months || [])
                                ) {
                                    finalized = true;
                                }
                            });
                        });
                    });

                    setIsFinalized(finalized);
                }
                setMembers(res?.data?.member_balances)
                setCumulativeBalance(res?.data?.comulativeBalance)
                setJointTotal(res?.data?.joint_total)
            }
        })
    }


    const unAssignedExpData =
        unAssignedData
            ?.map((cat: any) => ({
                ...cat,
                expenses: cat.expenses.filter(
                    (exp: any) => !(!exp.is_visible_in_payment_screen && exp.is_unpaid === 0)
                ),
            }))
            .filter((cat: any) => cat.expenses.length > 0) || [];


    const getSummaryList = (paymentsBy: any[]) => {
        const membersList = hhMembers?.data?.data || [];
        const list = membersList.map((item: any) => {
            const isMe = profile?.id && String(profile.id) === String(item?.user?.id);
            const labelName = isMe ? "Me" : item?.user?.name;
            const userId = item?.user?.id;
            
            const paymentEntry = paymentsBy?.find(
                (p: any) => String(p.user_id) === String(userId)
            );
            const amount = paymentEntry ? paymentEntry.amount : 0;
            
            return {
                label: labelName,
                amount: amount
            };
        });

        const jointEntry = paymentsBy?.find(
            (p: any) => String(p.user_id) === "-1" || String(p.user_id) === "01" || p.name?.toLowerCase().includes("joint")
        );
        const jointAmount = jointEntry ? jointEntry.amount : 0;
        
        list.push({
            label: "Joint Accounts",
            amount: jointAmount
        });

        return list;
    };

    //  const is_finalized = isDateFinalized(date, expenses?.data?.data?.finalized_months || []);
    if (unAssignedExpenses.loading || hhMembers.loading) {
        return <div>Loading...</div>
    }

    return (
        <div>
            {!fromReport &&
                <div className="m-0">
                    <TopHeader headerName="Payment" />
                </div>
            }
            {/* {!isFinalized && unAssignedExpData?.length > 0 ?
                <div>You haven't finalized the contribution yet. Kindly finalize it before viewing the payment.</div>
                : */}

            <div className="page-padding-x">
                <div className="com-input-grp d-flex justify-content-between mt-3 mb-2">
                    <label className="form-label-larg">Finalized Balances
                        <abbr
                            data-tooltip-id={'FinalizedBalancesInfo'}
                            className="text-decoration-none cursor-pointer"
                        >
                            {" "}
                            <i className="icon-info ms-2"></i>
                        </abbr></label>
                    <ReactTooltip
                        style={{
                            zIndex: "1",
                            wordBreak: "break-word",
                            maxWidth: "90%",
                        }}
                        id={'FinalizedBalancesInfo'}
                        place="bottom"
                        content={"Finalized balances are the cumulative total of all balances that have been finalized on the Contributions screen and all payments. If a month has not yet been finalized on the Contributions screen, the balances will not appear on the Payments screen."}
                    />
                    <label className="form-label-larg">${!isFinalized ? 0 : cumulativeBalance}</label>
                </div>
                {members && members.length > 0 && members.map((ele: any) => {
                    console.log("ele: ", ele)
                    return (
                        <div className="member-balance-item">
                            <div className="member-info">
                                <img
                                    src={ele?.profilePic || dummyUser}
                                    alt={ele?.member_name}
                                    className="member-avatar"
                                />
                                <label className="member-name">
                                    {ele?.member_name}
                                </label>
                            </div>
                            {!isFinalized ?
                                <label className={`member-balance`}>
                                    $0
                                </label>
                                :
                                <label className={`member-balance ${ele?.balance >= 0 ? 'positive' : 'negative'}`}>
                                    {ele?.balance >= 0 ? '+' : ''}{ele?.balance}
                                </label>
                            }
                        </div>
                    )
                })}

                {/* Joint Accounts Balance Row */}
                <div className="member-balance-item">
                    <div className="member-info">
                        <img
                            src={dummyUser}
                            alt="Joint Accounts"
                            className="member-avatar"
                        />
                        <label className="member-name">
                            Joint Accounts
                        </label>
                    </div>
                    {!isFinalized ?
                        <label className={`member-balance`}>
                            $0
                        </label>
                        :
                        <label className={`member-balance ${Number(jointTotal) >= 0 ? 'positive' : 'negative'}`}>
                            {Number(jointTotal) >= 0 ? '+' : ''}{jointTotal}
                        </label>
                    }
                </div>
            </div>

            <PaymentChart fromReport={fromReport} members={payerOptions} />

            <div className='summary-section'>
                <h3 className='summary-title'>Summary</h3>

                {/* Total Hours Projected */}
                <div
                    className='summary-item'
                    tabIndex={0}
                    role='button'
                    aria-expanded={expandedSections.totalPaymentMade}
                    onClick={() => toggleSection('totalPaymentMade')}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            toggleSection('totalPaymentMade');
                        }
                    }}
                >
                    <div className='summary-item-header'>
                        <div className='summary-item-left'>
                            <span className='summary-item-label'>Total Payments Made</span>
                            <span className='summary-item-arrow'>
                                <img className={`accordion-arrow ${expandedSections.totalPaymentMade ? 'expanded' : ''}`} src={chevRight} alt="" />
                            </span>
                        </div>
                        <span className='summary-item-value'>
                            ${totalPaymentMade || 0}
                        </span>
                    </div>
                </div>

                {expandedSections.totalPaymentMade && (
                    <div className='summary-item-expanded'>
                        {getSummaryList(totalPaymentMadeBy).map((member: any, idx: number) => {
                            return (
                                <div className='summary-sub-item' key={idx}>
                                    <span className='summary-sub-label'>{member.label}</span>
                                    <span className='summary-sub-value'>${member.amount}</span>
                                </div>
                            )
                        })}
                    </div>
                )}

                <div
                    className='summary-item'
                    tabIndex={0}
                    role='button'
                    aria-expanded={expandedSections.totalPaymentReceived}
                    onClick={() => toggleSection('totalPaymentReceived')}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            toggleSection('totalPaymentReceived');
                        }
                    }}
                >
                    <div className='summary-item-header'>
                        <div className='summary-item-left'>
                            <span className='summary-item-label'>Total Payments Received</span>
                            <span className='summary-item-arrow'>
                                <img className={`accordion-arrow ${expandedSections.totalPaymentReceived ? 'expanded' : ''}`} src={chevRight} alt="" />
                            </span>
                        </div>
                        <span className='summary-item-value'>
                            ${totalPaymentReceived || 0}
                        </span>
                    </div>
                </div>
                {expandedSections.totalPaymentReceived && (
                    <div className='summary-item-expanded'>
                        {getSummaryList(totalPaymentReceivedBy).map((member: any, idx: number) => {
                            return (
                                <div className='summary-sub-item' key={idx}>
                                    <span className='summary-sub-label'>{member.label}</span>
                                    <span className='summary-sub-value'>${member.amount}</span>
                                </div>
                            )
                        })}
                    </div>
                )}
            </div>

            <div className='d-flex info-box'>
                <abbr
                    data-tooltip-id={"balance-info"}
                    className="text-decoration-none cursor-pointer"
                >
                    {" "}
                    <i className="icon-info ms-2"></i>
                </abbr>
                <label className="info-text">
                    All balances are based on information entered or provided by users. Justivide does not guarantee the accuracy of any amounts listed above.
                </label>
            </div>
            {/* // } */}
        </div>
    );
}

export default PaymentReport;
